import { dayjs } from 'date';

export const DEFAULT_DAYS = dayjs().add(7, 'days');
export const DEFAULT_OPTIONS = [
  {
    label: 'Next 2 days',
    value: dayjs().add(2, 'days'),
  },
  {
    label: 'Next 7 days',
    value: dayjs().add(7, 'days'),
  },
  {
    label: 'Next 14 days',
    value: dayjs().add(14, 'days'),
  },
  {
    label: 'Last 7 days',
    value: dayjs().subtract(7, 'days'),
  },
  {
    label: 'Last 30 days',
    value: dayjs().subtract(30, 'days'),
  },
  {
    label: 'Last 90 days',
    value: dayjs().subtract(90, 'days'),
  },
];
